import React from "react";
import { BsSpeedometer } from "react-icons/bs";
import { IoDiamondOutline } from "react-icons/io5";
const AppDeli = () => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 items-center w-full py-10 md:px-28 px-10">
        {/* First Item */}
        <div className="my-2 py-5 md:pr-10 border-b border-b-gray-500 pb-10">
          <IoDiamondOutline className=" text-gray-700" size={40} />
          <h1
            style={{}}
            className=" font-light md:text-4xl text-2xl text-pink-600 uppercase mt-2"
          >
            Vision
          </h1>
          <p className="font-normal text-md text-gray-700 text-left mt-8">
            To Provide solutions that improve efficiency, productivity, and
            profitability for businesses.
          </p>
        </div>
        {/* Second Item */}
        <div className="my-2 py-5 md:pl-10 border-b border-b-gray-500 pb-10">
          <BsSpeedometer className=" text-gray-700" size={40} />
          <h1
            style={{}}
            className=" font-light md:text-4xl text-2xl text-pink-600 uppercase mt-2"
          >
            Mission
          </h1>
          <p className="font-normal text-md text-gray-700 text-left mt-8">
            Our mission is to provide innovative and reliable technology
            solutions to help our clients meet their business objectives and
            stay ahead of the competition.
          </p>
        </div>
      </div>
    </>
  );
};
export default AppDeli;
